import axios from '@axios'

const PREFIX = '/modelos'

export default {
  source: null,
  CancelToken: null,

  getModelos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getModelo(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  getModeloEmpresa(id) {
    return axios.get(`${PREFIX}/modelo-empresa/${id}`)
  },

  updateModelo(id, modelo, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel
    return axios.put(`${PREFIX}/${id}`, modelo, { cancelToken: this.source.token })
  },

  createModelo(modelo) {
    return axios.post(`${PREFIX}/add`, modelo)
  },

  deleteModelo(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getDocumentos(depId, novoModelo) {
    return axios.get(`${PREFIX}/documentos?departamentoId=${depId}&novoModelo=${novoModelo}`)
  },

  getModelosResumidos(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  cancelarEnvio() {
    this.source.cancel()
  },
}
